import { render, staticRenderFns } from "./MissYou.vue?vue&type=template&id=e4ecf650&scoped=true&"
import script from "./MissYou.vue?vue&type=script&lang=js&"
export * from "./MissYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ecf650",
  null
  
)

export default component.exports